export const AddonIdDiscover = 'com.atlassian.jira.emcee__enduser-discover';
